module.exports = __webpack_public_path__ + "static/img/banner1.b6317171.png";